import {
  postApi,
  getApi,
  getApiErrorAdmin,
  postApiErrorAdmin,
} from "../utils/common";

// 管理画面-お知らせ一覧データ取得
export const getNoticeList = async (searchCondition) => {
  const urlPath = "/api/admin/notice/list/?";
  const searchParams = new URLSearchParams({ ...searchCondition });
  try {
    const json = await getApi(urlPath + searchParams);
    return json;
  } catch (e) {
    getApiErrorAdmin(e, urlPath, searchParams);
  }
};

// 新規お知らせ作成
export const postAddNotice = async (data) => {
  const urlPath = "/api/admin/notice/add/";
  const postData = { ...data };
  try {
    const json = await postApi(urlPath, postData);
    return json;
  } catch (e) {
    postApiErrorAdmin(e, urlPath, postData);
  }
};

// 講座一覧データ取得
export const getCourseList = async (searchCondition, offsetNum, siteId) => {
  const urlPath = "/api/admin/notice/course/list/?";
  const searchParams = new URLSearchParams({
    ...searchCondition,
    offset_num: offsetNum,
    site_id: siteId,
  });
  try {
    const json = getApi(urlPath + searchParams);
    return json;
  } catch (e) {
    getApiErrorAdmin(e, urlPath, searchParams);
  }
};

// 管理画面-お知らせ詳細データ取得
export const getNoticeDetail = async (id) => {
  const urlPath = "/api/admin/notice/detail/?";
  const searchParams = new URLSearchParams({ id: id });
  try {
    const json = await getApi(urlPath + searchParams);
    return json;
  } catch (e) {
    getApiErrorAdmin(e, urlPath, searchParams);
  }
};

// 管理画面-お知らせ公開者一覧
export const getPublisherList = async (noticeId, searchCondition) => {
  const urlPath = "/api/admin/notice/publisherList/?";
  const searchParams = new URLSearchParams({
    id: noticeId,
    ...searchCondition,
  });
  try {
    const json = await getApi(urlPath + searchParams);
    return json;
  } catch (e) {
    getApiErrorAdmin(e, urlPath, searchParams);
  }
};

// お知らせ情報更新
export const postUpdateNotice = async (noticeId, data) => {
  const urlPath = "/api/admin/notice/update/";
  const postData = { id: noticeId, ...data };
  try {
    const json = await postApi(urlPath, postData);
    return json;
  } catch (e) {
    postApiErrorAdmin(e, urlPath, postData);
  }
};

// 管理画面-カテゴリー覧データ取得
export const getCategoryList = async () => {
  const urlPath = "/api/admin/notice/category/list/all/?";
  try {
    const json = await getApi(urlPath);
    return json;
  } catch (e) {
    getApiErrorAdmin(e, urlPath);
  }
};

// 管理画面-カテゴリー覧データ取得
export const getCategorySearchList = async (searchCondition) => {
  const urlPath = "/api/admin/notice/category/list/?";
  const searchParams = new URLSearchParams({ ...searchCondition });
  try {
    const json = await getApi(urlPath + searchParams);
    return json;
  } catch (e) {
    getApiErrorAdmin(e, urlPath, searchParams);
  }
};

// 新規お知らせカテゴリー作成
export const postAddNoticeCategory = async (data) => {
  const urlPath = "/api/admin/notice/category/add/";
  const postData = { ...data };
  try {
    const json = await postApi(urlPath, postData);
    return json;
  } catch (e) {
    postApiErrorAdmin(e, urlPath, postData);
  }
};

// 管理画面-お知らせカテゴリー取得
export const getNoticeCategory = async (id) => {
  const urlPath = "/api/admin/notice/category/detail/?";
  const searchParams = new URLSearchParams({ id: id });
  try {
    const json = await getApi(urlPath + searchParams);
    return json;
  } catch (e) {
    getApiErrorAdmin(e, urlPath, searchParams);
  }
};

// お知らせカテゴリー更新
export const postUpdateNoticeCategory = async (categoryId, data) => {
  const urlPath = "/api/admin/notice/category/update/";
  const postData = { ...data, id: categoryId };
  try {
    const json = await postApi(urlPath, postData);
    return json;
  } catch (e) {
    postApiErrorAdmin(e, urlPath, postData);
  }
};
